// src/color.ts
function darkenColor(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16);
  const r = Math.max(0, (num >> 16) - Math.round(2.55 * percent));
  const g = Math.max(0, (num >> 8 & 255) - Math.round(2.55 * percent));
  const b = Math.max(0, (num & 255) - Math.round(2.55 * percent));
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, "0")}`;
}

export { darkenColor };
//# sourceMappingURL=color.js.map
//# sourceMappingURL=color.js.map